import * as React from 'react';
import {StatelessComponent} from 'react';
import './styles.sass';

interface IVideoSettingsHeaderProps {
  children?: any;
  onClose?: () => void;
}

export const VideoSettingsHeader: StatelessComponent<IVideoSettingsHeaderProps> = ({
  children,
  onClose,
}: IVideoSettingsHeaderProps) => (
  <div className={'video-settings-header'}>
    <span className={'video-settings-header__title'}>
      {children || 'Audio/Video preferences'}
    </span>
    <span className={'video-settings-header__close'} onClick={onClose}>X</span>
  </div>
);
